<template>
<router-view></router-view>
</template>

<script>
import axios from 'axios'
import Notify from '@/config/mixins/notify'

export default {
    mixins: [Notify],

    created() {
        if (!this.$store.state.usuario) {
            this.$router.push({
                name: 'login'
            })
        } else {
            axios.defaults.headers.common['authorization'] = 'Bearer ' + this.$store.state.usuario.token
        }
    },


};
</script>

<style>
.page-title {
    font-weight: bold !important;
    color: #fff !important;
}

.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: -25px;
    margin-bottom: 0px;
}

.tableRow {
    font-weight: 400 !important;
}

.paginated-table table>tbody>tr>td {
    padding: 0px !important;
    padding-right: 7px !important;
}

.btn-title {
    padding-top: 10px;
}

.uppercase {
    text-transform: uppercase;
}

input {
    text-transform: uppercase;
}

textarea {
    text-transform: uppercase;
}

.lowercase {
    text-transform: lowercase !important;
}

.capitalize {
    text-transform: capitalize;
}

.text-secondary {
    color: rgb(98, 97, 97) !important;
}

.menuTable {
    margin-right: 50% !important;
}

.menuTableItem {
    font-weight: bold;
}

.formView {
    margin-top: -35px !important;
}

.validErro {
    margin-top: -10px !important;
    color: red;
    font-weight: 400;
}

.text-site {
    color: #002bdc !important;
}

.md-table-head-label {
    font-weight: 500;
    color: #626161;
}

.label-view {
    font-weight: 500;
    font-size: 0.910rem;
}

.text-view {
    font-weight: 400;
    font-size: 0.910rem;
}

.rows-relatorio {
    margin-top: 10px;
}
</style>
